import * as actions from '../actions/updateTab';
import * as ActionTypes from '../actions/index';
import { requestApplicationPremiumSettings } from '../actions/applicationPolicy';
import xs from 'xstream';
import BASE_URL from './variables';
import sampleCombine from 'xstream/extra/sampleCombine';
import { UPDATED_LNC_MN } from '../helpers/constants';

export function requestUpdateTabTagsDescription(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_UPDATE_TAB_TAGS_DESCRIPTION);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/Applications/UpdateTagsMessage',
            category: 'requestUpdateTabTagsDescription',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestUpdateTabTagsDescription')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getUpdateTabTagsDescriptionSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateTabTagsDescriptionError(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateTabTagsDescription')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getUpdateTabTagsDescriptionFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function getAllPreviousUpdates(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_ALL_PREVIOUS_UPDATES);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/Applications/Updates/' + action.payload ,
            category: 'getAllPreviousUpdates',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('getAllPreviousUpdates')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetAllPreviousUpdates(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseGetAllPreviousUpdates(sources) {
    let httpResponse$ = sources.HTTP
        .select('getAllPreviousUpdates')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAllPreviousUpdates(response));

    return {
        ACTION: httpResponse$
    };
}

export function getUpdateQuestions(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_UPDATE_QUESTIONS);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/Applications/UpdateQuestions',
            category: 'getUpdateQuestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('getUpdateQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetUpdateQuestions(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseGetUpdateQuestions(sources) {
    let httpResponse$ = sources.HTTP
        .select('getUpdateQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveUpdateQuestions(response));

    return {
        ACTION: httpResponse$
    };
}

export function postUpdatePolicyForm(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_UPDATE_POLICY_FORM)
        .map(action => ({
            url: BASE_URL + 'api/Applications/Update',
            category: 'postUpdatePolicyForm',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postUpdatePolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostUpdatePolicyFrom(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadRequestPostUpdatePolicyForm(sources) {
    let httpResponse$ = sources.HTTP
        .select('postUpdatePolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >= 300)
        .map(response => actions.receiveBadRequestPostUpdatePolicyForm(response.response.body.message));

    return {
        ACTION: httpResponse$
    };
}

export function postNoChangesUpdatePolicyForm(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM)
        .map(action => ({
            url: BASE_URL + 'api/Applications/Update',
            category: 'postNoChangesUpdatePolicyForm',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postNoChangesUpdatePolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostNoChangesUpdatePolicyForm(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadRequestNoChangesPostUpdatePolicyForm(sources) {
    let httpResponse$ = sources.HTTP
        .select('postNoChangesUpdatePolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >= 300)
        .map(response => actions.receiveBadRequestPostUpdatePolicyForm(response.response.body.message));

    return {
        ACTION: httpResponse$
    };
}

export function getCostsSummary(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_COSTS_SUMMARY)
        .map(action => ({
            url: BASE_URL + 'api/Applications/' + action.payload + '/Summary',
            category: 'getCostsSummary',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getCostsSummary')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveCostsSummary(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedToGetCostsSummary(sources) {
    let httpResponse$ = sources.HTTP
        .select('getCostsSummary')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status != 200)
        .map(response => actions.failedToGetCostsSummary(response));

    return {
        ACTION: httpResponse$
    };
}

export function refreshPremiumSettingsAfterLnCChange(sources) {
    const updateSuccess$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_POST_UPDATE_POLICY_FORM)
        .map(action => {
            const applicationId = action.payload?.applicationId;
            if (!applicationId) {
                return null;
            }
            //Check if LnC question has a value in the update request
            const lncAnswerAmount = action.payload?.policyUpdateAnswersDtos
                ?.find(q => q.questionMachineName === UPDATED_LNC_MN)?.amount;
            // If it has, request application premium settings refresh
            if (lncAnswerAmount != null) {
                return requestApplicationPremiumSettings({ id: applicationId });
            }
            return null;
        })
        .filter(action => action !== null);
    return {
        ACTION: updateSuccess$
    };
}
